import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const PageBreadcrumbs = ({ items, sx = {}, backPath, showBackButton = true }) => {
  const navigate = useNavigate();

  if (!items || items.length === 0) return null;

  const defaultBackPath = items.length > 1 ? items[items.length - 2].path : null;
  const actualBackPath = backPath || defaultBackPath;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {showBackButton && actualBackPath && (
        <Box
          onClick={() => navigate(actualBackPath)}
          sx={{
            mr: 0.5,
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            cursor: 'pointer',
            color: '#64748b',
            backgroundColor: '#f1f5f9',
            border: '1px solid #e2e8f0',
            '&:hover': { backgroundColor: '#e2e8f0', color: '#1e293b' },
            flexShrink: 0
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 18 }} />
        </Box>
      )}
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.5,
        py: 0.75,
        ...sx
      }}
    >
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: '#94a3b8' }} />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.path) {
            return (
              <Typography
                key={index}
                sx={{
                  color: '#1E88E5',
                  fontWeight: 700,
                  letterSpacing: '0.02em',
                  textTransform: 'uppercase'
                }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              component={RouterLink}
              to={item.path}
              underline="none"
              sx={{
                color: '#64748b',
                fontWeight: 400, 
                letterSpacing: '0.02em',
                textTransform: 'uppercase',
                transition: 'color 0.2s',
                '&:hover': {
                  color: '#3b82f6',
                },
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
    </Box>
  );
};

PageBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ).isRequired,
  sx: PropTypes.object,
};

export default PageBreadcrumbs;
